import { Home, Menu } from 'lucide-react'
import { Link } from 'react-router-dom'
import { routes } from '@/shared/constants'
import { NotificationsBell } from '@/features/notifications/NotificationsBell'
import { PendingBillingsAlert } from '@/features/billing/components/PendingBillingsAlert'

interface TopbarProps {
  /** Callback al tocar la hamburguesa (mobile). En `≥md` la hamburguesa está oculta. */
  onMenuClick: () => void
}

export function Topbar({ onMenuClick }: TopbarProps) {
  return (
    <div className="sticky top-0 z-20 flex items-center justify-between gap-2 border-b border-line bg-panel px-4 py-3 md:px-8 md:py-3.5">
      <button
        type="button"
        aria-label="Abrir menú de navegación"
        onClick={onMenuClick}
        className="grid h-[38px] w-[38px] place-items-center rounded-lg border border-line bg-panel text-ink-muted hover:text-ink md:hidden"
      >
        <Menu className="h-[18px] w-[18px]" />
      </button>

      <div className="ml-auto flex items-center gap-2">
        <PendingBillingsAlert />
        <Link
          to={routes.public.landing}
          aria-label="Ir al sitio"
          title="Ir al sitio"
          className="grid h-[38px] w-[38px] place-items-center rounded-lg border border-line bg-panel text-ink-muted hover:text-ink"
        >
          <Home className="h-[18px] w-[18px]" />
        </Link>
        <NotificationsBell />
      </div>
    </div>
  )
}
